import generateSettings from '../helpers/Settings';
import styles from './styles';
import content from './content';

export default (container = document) => {
  const modules = container.querySelectorAll('[data-cms-module-shoppable-image]');
  modules.forEach((module, i) => {
    const module_name = 'ShoppableImage';
    const settingsElement = module.querySelector('[data-settings]');
    const settings = generateSettings(settingsElement ? settingsElement.innerHTML : '');

    if (!settings) {
      return;
    }

    const styles_html = styles(settings, module_name, i);
    const content_html = content(settings, module_name, i);
    const module_width = `Section--${settings.module_width} Section--mobile-${settings['module_width--mobile']}`;

    const new_html = `
    <section
      id="Module-${module_name}--${i}"
      data-section-id="${module_name}--${i}"
      data-section-type=""
      class="CMS-Module Module-${module_name} Section ${module_width}"
    >
      <div class="Section__bg" style="background-image:url('${settings.background_texture}');">
        <div class="Section__container">
          ${content_html}
        </div>
      </div>
    </section>
    ${styles_html}
    `;

    module.innerHTML = new_html;
  });
};
